import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";


export const useGetSearchParams = (defaultValues= {}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  // Convert URLSearchParams → JS Object (arrays included)
  const parseParams = () => {
    const obj: Record<string, any> = { ...defaultValues };
    
    for (const [key, value] of searchParams.entries()) {
      if (value.includes(",")) {
        obj[key] = value.split(","); // convert comma string → array
      } else {
        obj[key] = value;
      }
    }
    
    return obj;
  };
  const [state, setState] = useState(parseParams());

  // Read initial values from URL
  useEffect(() => {
    setState(parseParams());
  }, [searchParams]);

  // Wrapper function to update state and URL both
  const updateState = (updater: any) => {
    setState(prev => {
      const updated = typeof updater === "function" ? updater(prev) : updater;

      const params = new URLSearchParams();

      // Convert object → URL params
      for (const key in updated) {
        const val = updated[key];

        if (val === undefined || val === null || val === "") continue;

        if (Array.isArray(val)) {
          params.set(key, val.join(",")); // array → comma
        } else {
          params.set(key, val);
        }
      }

      setSearchParams(params);

      return updated;
    });
  };

  return [state, updateState] as const;
};
